//Array.prototype.remove = function () {
//    var what, a = arguments, L = a.length, ax;
//    while (L && this.length) {
//        what = a[--L];
//        while ((ax = this.indexOf(what)) !== -1) {
//            this.splice(ax, 1);
//        }
//    }
//    return this;
//};

//Array.prototype.addRange = function(arrayToAdd) {
//    if (!arrayToAdd) return;
//    for (var i = 0; i < arrayToAdd.length; i++) {
//        this.push(arrayToAdd[i]);
//    }
//}

// Here's a link to a blog post with little more info about this: http://jointjs.com/blog/get-transform-to-element-polyfill.html
SVGElement.prototype.getTransformToElement = SVGElement.prototype.getTransformToElement || function (toElement) {
    return toElement.getScreenCTM().inverse().multiply(this.getScreenCTM());
};



if (typeof String.prototype.startsWith != 'function') {
    String.prototype.startsWith = function (str) {
        if (this.length > this.length) return false;
        return this.slice(0, str.length) == str;
    };
}

if (!String.prototype.endsWith) {
    Object.defineProperty(String.prototype, 'endsWith', {
        value: function (searchString, position) {
            var subjectString = this.toString();
            if (position === undefined || position > subjectString.length) {
                position = subjectString.length;
            }
            position -= searchString.length;
            var lastIndex = subjectString.indexOf(searchString, position);
            return lastIndex !== -1 && lastIndex === position;
        }
    });
}

if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
              ? args[number]
              : match
            ;
        });
    };
}

if (!String.prototype.padLeft) {
    String.prototype.padLeft = function (padString, length) {
        var str;
        str = this;
        while (str.length < length) {
            str = padString + str;
        }
        return str;
    };
}
 
if (!String.prototype.padRight) {
    String.prototype.padRight = function (padString, length) {
        var str;
        str = this;
        while (str.length < length) {
            str = str + padString;
        }
        return str;
    };
}

if (!String.prototype.format) {
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
              ? args[number]
              : match;
        });
    };
}

if (!String.prototype.isNullOrWhiteSpace) {
    String.prototype.isNullOrWhiteSpace = function () {
        if (/\S/.test(this)) {
            // string is not empty and not just whitespace
            return false;
        }
        return true;
    };
}

if (!Date.prototype.fiscalYear) {
    Date.prototype.fiscalYear = function () {
        // Note getMonth() returns a zero based month so 5 is June.
        return this.getMonth() > 5 ? this.getFullYear() + 1 : this.getFullYear();
    };
}
if (!String.prototype.splice) {
    /**
     * {JSDoc}
     *
     * The splice() method changes the content of a string by removing a range of
     * characters and/or adding new characters.
     *
     * @this {String}
     * @param {number} start Index at which to start changing the string.
     * @param {number} delCount An integer indicating the number of old chars to remove.
     * @param {string} newSubStr The String that is spliced in.
     * @return {string} A new string with the spliced substring.
     */
    String.prototype.splice = function(start, delCount, newSubStr) {
        return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
    };
}

if (!Date.prototype.stdTimezoneOffset) {
    Date.prototype.stdTimezoneOffset = function() {
        var jan = new Date(this.getFullYear(), 0, 1);
        var jul = new Date(this.getFullYear(), 6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }
}
if (!Date.prototype.dst) {
    Date.prototype.dst = function() {
        return this.getTimezoneOffset() < this.stdTimezoneOffset();
    }
}

if (!Date.prototype.getTimeZoneOffsetInMilliseconds) {
    Date.prototype.getTimeZoneOffsetInMilliseconds = function() {
        return this.getTimezoneOffset() * 60000;
    }
}

if (!window.crypto) {
    window.crypto = window.crypto || window.msCrypto;    
}

if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function (searchElement, fromIndex) {

            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(searchElement, elementK) is true, return true.
                // c. Increase k by 1. 
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                k++;
            }

            // 8. Return false
            return false;
        }
    });
}

var isUndefinedNullOrWhiteSpace = function (subject) {
    if (subject == undefined) return true;
    return subject.isNullOrWhiteSpace();
}